import { render, staticRenderFns } from "./GameBlock.vue?vue&type=template&id=8851330a&scoped=true&"
import script from "./GameBlock.vue?vue&type=script&lang=js&"
export * from "./GameBlock.vue?vue&type=script&lang=js&"
import style0 from "./GameBlock.vue?vue&type=style&index=0&id=8851330a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8851330a",
  null
  
)

export default component.exports